import POShipmentSearchType from './POShipmentSearchTypes';

export const getShipmentInfoListInProgress = (payload) => {
  return { type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST, payload };
};

export const getShipmentInfoListInSuccess = (payload) => {
  return {
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_SUCCESS,
    payload,
  };
};

export const getShipmentInfoListListInFail = (payload) => {
  return {
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_FAIL,
    payload,
  };
};

export const getShipmentInfoListListInReset = () => {
  return {
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_RESET,
  };
};

export const updateShipmentInfoListRequest = (payload) => {
  return {
    type: POShipmentSearchType.UPDATE_SHIPMENT_INFO_LIST_REQUEST,
    payload,
  };
};

export const saveShipmenOtherDetailsInProgress = (payload) => {
  return {
    type: POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS,
    payload,
  };
};

export const saveShipmenOtherDetailsInSuccess = (payload) => {
  return {
    type: POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_SUCCESS,
    payload,
  };
};

export const saveShipmenOtherDetailsInFail = (payload) => {
  return {
    type: POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_FAIL,
    payload,
  };
};

export const updateShipmentInfoCheckedItems = (payload) => {
  return {
    type: POShipmentSearchType.UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS,
    payload,
  };
};

export const setShipmentSearchExportModal = (payload) => {
  return {
    type: POShipmentSearchType.SET_SHIPEMENT_SEARCH_EXPORT_TOGGLE,
    payload,
  };
};
